import React from 'react';
import moment from 'moment';
import 'moment/locale/es-us';

import { LinkContainer } from 'react-router-bootstrap';

import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

const ProjectSummary = ({ project }) => {
  return (
    <div>
      <Card style={{ marginBottom: 20 }} className='shadow-sm'>
        <Card.Header as='h5'>{project.title}</Card.Header>
        <Card.Body>
          <Card.Text>{project.content}</Card.Text>
          <footer className='blockquote-footer m-3'>
            Autor{' '}
            <cite title='Source Title'>
              {project.authorFirstName} {project.authorLastName}
            </cite>{' - '}
            {moment(project.createdAt.toDate())
              .locale('es')
              .calendar()}
          </footer>
          <LinkContainer to={'/project/' + project.id}>
            <Button variant='primary' className='shadow-sm'>
              Ver Proyecto
            </Button>
          </LinkContainer>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ProjectSummary;
